export default function Skeleton() {
    return (
        <div
            data-testid="skeleton-loading"
            aria-hidden="true"
            className="mx-auto max-w-7xl px-5 py-20 sm:px-8"
        >
            <div className="h-3 w-40 animate-pulse rounded-full bg-white/10" />
            <div className="mt-6 h-10 w-64 animate-pulse rounded-full bg-white/10 sm:w-96" />
            <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-5">
                {[0, 1, 2].map((i) => (
                    <div
                        key={i}
                        className="h-36 animate-pulse rounded-2xl border border-white/5 bg-white/5"
                    />
                ))}
            </div>
            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-5">
                {[0, 1, 2].map((i) => (
                    <div
                        key={i}
                        className="h-36 animate-pulse rounded-2xl border border-white/5 bg-white/5"
                    />
                ))}
            </div>
        </div>
    );
}
